import AggregateVideosView from "./AggregateVideosView";
import { Button } from "@/components/ui/button";
import { Doc } from "@cvx/_generated/dataModel";
import { NewPostDialog } from "./NewPostDialog";
import { Sparkle } from "lucide-react";
import { User } from "~/types";
import { useNavigate } from "@tanstack/react-router";

interface CreatorLandingScreenProps {
  campaign?: Partial<Doc<"campaigns">>;
  app?: {
    name: string;
    logo?: string;
  };
  contract?: Partial<Doc<"creatorContracts">>;
  user?: User | null | undefined;
  refetchDashboardData?: () => void;
}

export default function CreatorLandingScreen({
  campaign,
  contract,
  user,
  refetchDashboardData,
}: CreatorLandingScreenProps) {
  const navigate = useNavigate();

  return (
    <div className="flex h-full w-full bg-secondary px-6 pb-6 dark:bg-black">
      <div className="z-10 mx-auto flex h-full w-full max-w-screen-xl flex-col">
        {/* Header Section */}
        <div className="flex justify-end items-center gap-2 relative bottom-28">
          <div className="flex items-center gap-4">
            <Button
              variant="outline"
              onClick={() => {
                navigate({
                  to: "/dashboard?create=true",
                  replace: true,
                });
              }}
              className="text-primary   flex items-center gap-2"
            >
              <Sparkle className="h-4 w-4" />
              Co-creator
              <span className="px-2 py-0.5 rounded-full text-xs font-semibold bg-orange-100 text-orange-700 dark:bg-orange-900 dark:text-orange-200">
                beta
              </span>
            </Button>
            <NewPostDialog
              campaign={campaign}
              contract={contract}
              refetchDashboardData={refetchDashboardData || (() => {})}
              user={user}
            />
          </div>
        </div>

        {/* Main Content Area */}
        <div className="flex-1 flex flex-col overflow-y-auto">
          {/* Affiliate Coupons Section */}
          {/* {user?.creator && (
            <div className="w-full mb-6 flex justify-center">
              <CreatorAffiliateCoupons creatorId={user.creator._id} />
            </div>
          )} */}

          {/* Aggregate Videos View */}
          {campaign && (
            <div className="w-full">
              <AggregateVideosView campaign={campaign as Doc<"campaigns">} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
